import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PercentPipe } from '@angular/common';
import { UserSettingsQuery } from '../../features/user-settings/state/user-settings.query';
import { filterNilValue } from '@datorama/akita';

@Pipe({
    name: 'formattedPercent$',
    standalone: true
})
export class FormattedPercentPipe extends PercentPipe implements PipeTransform {
    constructor(
        @Inject(LOCALE_ID) locale: string,
        private userSettingsQuery: UserSettingsQuery
    ) {
        super(locale);
    }
    // @ts-ignore
    transform(
        number: number,
        nullValue?: string,
        overrideDigitsInfo?: string,
        useShortNumberFormat?: boolean
    ): Observable<string> {
        return combineLatest([
            this.userSettingsQuery.selectGlobalSetting$('LOCALE'),
            this.userSettingsQuery.selectGlobalSetting$('DIGITS_PERCENT').pipe(
                filterNilValue(),
                map((digits) => '1.' + digits.join('-'))
            )
        ]).pipe(
            map(([locale, digitsInfo]) => {
                return number == null
                    ? nullValue
                    : super.transform(number, overrideDigitsInfo || digitsInfo, locale);
            })
        );
    }
}
